import { render, staticRenderFns } from "./WelcomeStepper.vue?vue&type=template&id=6221abe0&scoped=true&"
import script from "./WelcomeStepper.vue?vue&type=script&lang=js&"
export * from "./WelcomeStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221abe0",
  null
  
)

export default component.exports